export function isObject<T>(value: unknown): value is T {
  return value !== null && typeof value === 'object';
}

export function isArray<T>(value: unknown): value is T[] {
  return Array.isArray(value);
}

export function isArrayOf<T>(
  value: unknown,
  predicate: (value: unknown) => value is T
): value is T[] {
  return isArray(value) && value.every(predicate);
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}
